/**
 * MobileCallBar – sticky CTA na dole ekranu, widoczny tylko na mobile
 * Wyświetla się wyłącznie na ekranach < 768px
 */
import { Phone } from 'lucide-react';
import { companyData } from '@/theme';

export default function MobileCallBar() {
  return (
    <>
      <style>{`
        .mobile-call-bar {
          display: none;
        }
       @media (max-width: 767px) {
         .mobile-call-bar {
           display: flex;
         }
         /* Dodaj padding na dole body żeby treść nie chowała się pod paskiem */
         body {
            padding-bottom: 80px;
         }
       }
      `}</style>
     <div
       className="mobile-call-bar"
       style={{
         position: 'fixed',
         bottom: 0,
         left: 0,
         right: 0,
         zIndex: 9999,
         alignItems: 'center',
         justifyContent: 'center',
          backgroundColor: 'transparent',
          padding: '0 1.25rem 1rem',
       }}
     >
       <a
         href={`tel:${companyData.phoneRaw}`}
         style={{
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           gap: '0.625rem',
           width: '100%',
           height: '52px',
           borderRadius: '12px',
            background: '#F5C400',
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
            border: 'none',
            boxShadow: '0 4px 16px rgba(0,0,0,0.22)',
           fontFamily: "'Manrope', sans-serif",
           fontWeight: 800,
           fontSize: '1.05rem',
           letterSpacing: '0.04em',
           textTransform: 'uppercase',
            color: '#0D1B3E',
           textDecoration: 'none',
         }}
          aria-label={`Zadzwoń: ${companyData.phone}`}
        >
          <Phone size={18} strokeWidth={2.5} />
          Zadzwoń: {companyData.phone}
        </a>
      </div>
    </>
  );
}
